import { NoddiDialog } from 'noddi-ui-web';

import { EditDiscountContent } from './EditDiscountContent';

type Props = {
  discountId: number;
  onClose: () => void;
  onSuccess: () => void;
};

export const EditDiscountDialog = ({ discountId, onClose, onSuccess }: Props) => (
  <NoddiDialog
    open
    onClose={onClose}
    title='Edit discount'
    description='Edit this ad-hoc discount.'
    className='sm:max-w-lg'
  >
    <EditDiscountContent discountId={discountId} onCancel={onClose} onSuccess={onSuccess} />
  </NoddiDialog>
);
